import { useEffect, useState } from "react";
import { useLocation } from "wouter";
import type { ComponentType } from "react";

export function withPageWrapper<P extends object>(WrappedComponent: ComponentType<P>) {
  const ComponentWithWrapper = (props: P) => {
    const [location] = useLocation();
    const [show, setShow] = useState(false);

    useEffect(() => {
      setShow(false);
      const timeout = setTimeout(() => setShow(true), 10);
      return () => clearTimeout(timeout);
    }, [location]);

    return (
      <div
        className={`transition-opacity duration-200 ease-in-out bg-[#F1F5F9] ${
          show ? "opacity-100" : "opacity-0"
        }`}
      >
        <WrappedComponent {...props} />
      </div>
    );
  };
  ComponentWithWrapper.displayName = `WithPageWrapper(${WrappedComponent.displayName || WrappedComponent.name || "Component"})`;
  return ComponentWithWrapper;
}